import { z } from "zod";
import { dmaSettingIngredientParameterDtoSchema } from "./dma-setting-ingredient-parameter.schema";
import { dmaSettingNumberParameterDtoSchema } from "./dma-setting-number-parameter.schema";
import { dmaSettingNumberRangeParameterDtoSchema } from "./dma-setting-number-range-parameter.schema";
import { dmaSettingStringParameterDtoSchema } from "./dma-setting-string-parameter.schema";
export const dmaSettingParameterDtoSchema = z.discriminatedUnion("kind", [
    dmaSettingIngredientParameterDtoSchema,
    dmaSettingNumberParameterDtoSchema,
    dmaSettingNumberRangeParameterDtoSchema,
    dmaSettingStringParameterDtoSchema,
]);
